import { Nudge } from "../types/nudge";

export const nudgeFallback: Nudge = {
  styles: {
    width: '376px',
    position: 'absolute',
    top: '0',
    right: '0',
    padding: '20px 5px 3px 20px',
    borderRadius: '10px',
    transform: 'translateY(calc(-100%))',
    scale: '0.9',
  },
  botMessage: {
    styles: {
      width: '100%',

      display: 'flex',
      gap: '14px',
      justifyContent : 'flex-end',
      alignItems: 'end'
    },
    avatar: {
      styles: {
        width: '53px',
        height: '53px',

        padding: '15px',
        
        borderRadius: '50%',
        backgroundColor: '#F8F8F8',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      src: '/assets/chat-bot-message-avatar.svg'
    },
    cloud: {
      styles: {
        fontFamily: 'Poppins, sans-serif',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '140%',
        display: '-webkit-box',
        overflow: 'hidden',
        WebkitBoxOrient: 'vertical',
        textOverflow: 'ellipsis'
      },
      container: {
        styles: {
          cursor: 'pointer',
          padding: '11px 16px',
          borderRadius: '8px',
          backgroundColor: '#F8F8F8',
        }
      }
    },
  },
  blurrer: {
    styles: {
      padding: '5px',
      backdropFilter: 'blur(10px)',
      borderRadius: '8px',
      backgroundColor: 'inherit'
    }
  },
  suggestionShips: {
    styles: {
      display: 'flex',
      flexDirection: 'column',
      gap: '7px',
      listStyle: 'none',
      padding: 0,
      alignItems: 'end',
    },
    chip: {
      styles: {
        borderRadius: '8px',
        // backgroundColor: 'rgba(113, 7, 84, 1)',
        background: 'rgba(0, 155, 255, 0.06)',
        color: 'white',
        padding: '10px 16px',
        fontFamily: 'Poppins, sans-serif',
        cursor: 'pointer',
        fontSize: '13px',
      }
    },
    rowContainer: {
      styles: {
        width: '100%',
      }
    }
  },
};